import { isEqual } from 'lodash'

import { joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'
import { isUUID } from '@sigmasms/commons'

import { macroCacheOptions, proxy, request, services } from '@/utils'

import { userTariffsInputFilter } from '@/components/services/tariffs/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

const cachedGet = Cache.wrapWithCache(async (key, id) => {
  return await request.get(joinURLPath(services.tariffs, id))
})

export default {
  name: 'Generator',

  mixins: [ proxy({ type: 'array' }) ],

  props: {
    readonly: Boolean
  },

  watch: {
    proxy: {
      handler() {
        this.fillTariff()
      },
      deep: true
    }
  },

  methods: {
    remove(index) {
      this.proxy.splice(index, 1)
    },

    _outputFilter(data) {
      return data.map((item, index) => {
        if (!isUUID(item)) {
          item.priority = index
        }

        return item
      })
    },

    transmitValue() {
      const proxy = this._outputFilter(this.proxy)
      if (!isEqual(proxy, this.value)) {
        this.$emit('input', proxy)
      }
    },

    async fillTariff() {
      const index = this.proxy.findIndex(isUUID)
      const id = this.proxy[index]
      if (id) {
        const data = await cachedGet(`${services.tariffs}:get:${id}`, id)
        this.proxy.splice(index, 1, userTariffsInputFilter(data))
      }
    }
  },

  render
}
